<script>
	import { tick } from 'svelte';
	import UserStore from './stores/user';
	import Router from 'svelte-spa-router'
	import mainRoutes from './routes.js';
	import { addMessages, init , locale } from "svelte-i18n";
	import { writable } from 'svelte/store';
	import { setContext } from 'svelte';
	import { push } from 'svelte-spa-router';
	import fetchData from './api.js';
	import ChatBox from './components/ChatBox.svelte';
	import { onMount } from 'svelte';
	
	let routes;
	let activeLink;






	// async function fetchPrinters() {
	// 	try {

	// 		qz.security.setCertificatePromise(function(resolve, reject) {
	// 			fetch("assets/signing/digital-certificate.txt", {cache: 'no-store', headers: {'Content-Type': 'text/plain'}})
	// 				.then(function(data) { data.ok ? resolve(data.text()) : reject(data.text()); });
	// 		});
	// 		qz.security.setSignatureAlgorithm("SHA512"); // Since 2.1
	// 		qz.security.setSignaturePromise(function(toSign) {
	// 			return function(resolve, reject) {
	// 				fetch("assets/signing/sign-message.php?request=" + toSign, {cache: 'no-store', headers: {'Content-Type': 'text/plain'}})
	// 					.then(function(data) { data.ok ? resolve(data.text()) : reject(data.text()); });
	// 			};
	// 		});


	// 		// Ensure QZ Tray is loaded and trusted
	// 		if (!qz.websocket.isActive()) {
	// 			await qz.websocket.connect();
	// 		}

	// 		// Get the list of available printers
	// 		let temp_printers = await qz.printers.find();
	// 		printers = temp_printers;
	// 		console.log('printers',printers);

	// 	} catch (error) {
	// 		console.error("Error fetching printers:", error);
	// 	}
	// }

	// fetchPrinters();


	

	// console.log('test',localStorage.getItem('user'))


	if (localStorage.getItem('user') ===null || localStorage.getItem('user')=='' || localStorage.getItem('user')=='{}') {		
		localStorage.setItem('user', '{}');		
		push('/login');
	} else {

		let saved_platforms = localStorage.getItem('platforms');
		platforms = saved_platforms ? JSON.parse(saved_platforms) : {};


		saved_platforms = localStorage.getItem('erp_platforms');
		erp_platforms = saved_platforms ? JSON.parse(saved_platforms) : {};

		// console.log(platforms)
		let uu = localStorage.getItem('user');
		let user = JSON.parse(localStorage.getItem('user'));
		UserStore.set(user)		

		// console.log('User Store:',user, UserStore);

	}

	onMount(() => {
		// Keep hook available for future app-level startup logic.
	});

	

	let languages = [
		{ code : 'he', name : 'עברית' , dir : 'rtl' },
		{ code : 'en', name : 'English' , dir : 'ltr' },
		{ code : 'ru', name : 'Русский' , dir : 'ltr' },
		{ code : 'ar', name : 'العربية' , dir : 'rtl' },
	]

	localStorage.setItem('languages',JSON.stringify(languages));

	import en from "./locales/en.json";
	import he from "./locales/he.json";
	import ru from "./locales/ru.json";
	import ar from "./locales/ar.json";
    //import Login from './pages/Login.svelte';

	addMessages("en", en);
	addMessages("he", he);
	addMessages("ru", ru);
	addMessages("ar", ar);

	// init({
	// 	initialLocale: "he",
	// });	

	export const selectedLanguage = writable('he');
	setContext('language', selectedLanguage);


	const savedLanguage = localStorage.getItem('language') || 'he';
	if (savedLanguage && languages.find(lang => lang.code === savedLanguage)) {
		selectedLanguage.set(savedLanguage);
		locale.set(savedLanguage);
	} else {
		localStorage.setItem('language', 'he');
		selectedLanguage.set('he');
		locale.set('he');
	}

	selectedLanguage.subscribe((lang) => {
		locale.set(lang);
		localStorage.setItem('language', lang);
	});


	init({
        initialLocale: savedLanguage,
        fallbackLocale: 'he',
    });

	$: direction = languages.find(lang => lang.code === $selectedLanguage)?.dir || 'ltr';


	routes = mainRoutes;

	if (typeof zap == 'undefined' || zap==false) {


		if (shippingo=="10") {
			push('/merchandiser/categories');
		}


		let temp_locations = $UserStore.settings?.shipping_settings?.datalogics_update_inventory_locations ?? [];
		if (!temp_locations.length) {
			push('/locations');
		}

		let temp_methods = $UserStore.settings?.shipping_settings?.shipping_method ?? [];

		if (shippingo=="1" || shippingo=="2") {
			
			if (!temp_methods.length) {
				push('/companies');
			}

		} else {

			if (temp_methods.length) {

				//console.log(temp_methods)

				for(let key in temp_methods) {
					shipping_push_supplier = temp_methods[key].shipping_push_supplier;
				}

			}

		}

		let temp_settings = $UserStore.settings?.shipping_settings?.shipping_push_supplier_name ?? '';
		if (temp_settings=='') {
			push('/settings');
		}
		
		

		if (typeof pushPage !== 'undefined' && pushPage!='') {

			console.log('inside push page')

			push('/'+pushPage);

		}



		
		docs_shipping_company_name = '"' + (platforms[shipping_push_supplier]?.name ?? 'MY APP') + '"'

	} else {

		routes = {
			...mainRoutes,
			'/': mainRoutes['/zap'],
		}
	}

</script>

<main class="dir-{direction}"> 
	<Router {routes}/>
	<!-- <ChatBox  /> -->
</main>
